import { AfterViewChecked, ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { HeaderComponent } from './core/layout/header/header.component';
import { FooterComponent } from './core/layout/footer/footer.component';
import { NavbarComponent } from './core/layout/navbar/navbar.component';
import { NavigationStart, Router } from '@angular/router';
import { SpinnerComponent } from './core/layout/spinner/spinner.component';
import { ErrorMsgInfo, SPINNER_AREA, User_Roles } from './core/model/common.model';
import { GlobalApiService } from './core/services/global-api.service';
import { CommonUtils } from './core/utils/common.utils';
declare global {
  var environment: {
    grantType: string;
    clientId: string;
    redirectURI: string;
    tokenURL: string;
  };
}
import { logindetails } from '../app/core/services/login/logindetails';
import { API_STATUS, ApiEnvNames, ApiPayload, ERROR_RESPONSE, FETCH_METHODS, SearchConfig } from './core/model/api.model';
import { jwtDecode } from 'jwt-decode';
import { ErrorPageComponent } from './core/layout/error-page/error-page.component';
import { CustomTourComponent } from './core/layout/custom-tour/custom-tour.component';
import { EventAdminMenu, menuItems, NavbarMenuItems, SuperAdminMenu } from './core/model/navbar.model';
import { FieldNames } from './core/model/form-fields.model';
import { CommonService } from './core/services/common.service';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ChatBotComponent } from './core/components/chat-bot/chat-bot.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NavbarComponent, SpinnerComponent, ErrorPageComponent, CustomTourComponent,MatIconModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewChecked, OnInit {
  @ViewChild(NavbarComponent)
  navbarComponent!: NavbarComponent;
  userLogin = false;
  readonly spinnerArea: typeof SPINNER_AREA = SPINNER_AREA;
  codeResponse: any;
  idToken: any;
  accessToken: any;
  refresToken: any;
  isActive = false;
  initialLoaderName = 'initialLoading'
  applicationStatus: 'Loading' | 'Error' | 'Render' = 'Loading';
  private _navbarInitialized = false;
  errorPageConfig: ErrorMsgInfo = {
    status: 404,
    title: 'PAGE NOT FOUND',
    description: 'We are sorry, but the page you requested was not found.'
  }
  currentUserAccessTkn: any;
  currentUserIDTkn: any
  commonService = inject(CommonService)
  constructor(private readonly dialog: MatDialog,readonly router: Router, private readonly globalApi: GlobalApiService, public commonUtils: CommonUtils, readonly cdr: ChangeDetectorRef
  ) {
    this.commonUtils.spinner('show', this.initialLoaderName)
    router.events.subscribe(async (event: any) => {
      if (event instanceof NavigationStart) {
        if (globalThis.location.href.includes('code')) {
          this.commonUtils.spinner('show');
          const url = globalThis.location.href.split('?')[1]
          if (url.includes('error')) {
            this.isActive = false;
            this.errorPageConfig = {
              status: 401,
              title: 'Unauthorized Access',
              description: "We are sorry, you can't access the page requested"
            }
            this.applicationStatus = 'Error';
            globalThis.location.hash = '#/unauthorized'
            this.router.navigateByUrl('/unauthorized')
            this.commonUtils.spinner('hide');
          }
          else {
            this.codeResponse = globalThis.location.href.split('?')[1].split('code=')[1].split('&')[0];
            sessionStorage.setItem('codeResponse', this.codeResponse)
           const details: any = {
              'grant_type':  globalThis.environment.grantType,
              'client_id':  globalThis.environment.clientId,
              'code': this.codeResponse,
              'redirect_uri':  globalThis.environment.redirectURI,
              'code_verifier': logindetails.codeVerifier,
            };
            const formBody = [];
            for (const property in details) {
              const encodedKey = encodeURIComponent(property);
              const encodedValue = encodeURIComponent(details[property]);
              formBody.push(`${encodedKey}=${encodedValue}`);
            }
            const body = formBody.join("&");
const tokenapi: ApiPayload = {
              'url':  globalThis.environment.tokenURL,
              'method': FETCH_METHODS['Post'],
              'headers': {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
              },
              'body': body,
              'type': 'token'
            }
            await this.globalApi.getDataFromDataSource(tokenapi).then((res: any) => {
              if (res !== null && res !== undefined && res !== '' && !res.hasOwnProperty('error')) {
                this.idToken = res.id_token;
                this.accessToken = res.access_token;
                this.refresToken = res.refresh_token;
                sessionStorage.setItem('token', this.accessToken);
                sessionStorage.setItem('Refresh_token', this.refresToken);
                sessionStorage.setItem('id_token', this.idToken);
                const currentTime = Date.now();
                sessionStorage.setItem('lastModifiedOn', currentTime.toString());
                setInterval(() => {
                  this.refreshToken();
                }, 900000);
                if (this.idToken !== null || this.accessToken !== null) {
                  const decodedIDToken: any = jwtDecode(this.idToken);
                  const decodedACCESSToken: any = jwtDecode(this.accessToken);
                  sessionStorage.setItem('CBL_IDTOKEN', JSON.stringify(decodedIDToken));
                  sessionStorage.setItem('CBL_ACCESSTOKEN', JSON.stringify(decodedACCESSToken));
                  this.currentUserAccessTkn = JSON.parse(sessionStorage.getItem('CBL_ACCESSTOKEN') ?? "");
                  this.currentUserIDTkn = JSON.parse(sessionStorage.getItem('CBL_IDTOKEN') ?? "");
                  const UserInfo: any = {
                    'userName': this.currentUserAccessTkn['name'],
                    'workdayId': this.currentUserIDTkn['WorkdayID']
                  }
                  sessionStorage.setItem('UserInfo', JSON.stringify(UserInfo))
                  if (sessionStorage.getItem('UserInfo')) {
                   this.assignMenuGroupAndRender();
                  }
                }
              } else {
                this.commonUtils.showMatSnackBar(ERROR_RESPONSE['tokenMissing'])
                sessionStorage.clear();
                globalThis.location.reload()
              }
            }).catch(err => {
              this.commonUtils.showMatSnackBar(ERROR_RESPONSE['tokenMissing'])
              console.info(err); 
              sessionStorage.clear();
              globalThis.location.reload();
            })
          }
        }
      }
    })
  }
  ngOnInit() {
    if (sessionStorage.getItem('UserInfo')) {
      this.assignMenuGroupAndRender();
    }
    setInterval(() => {
      this.refreshToken();
    }, 600000 * 5);
  }
  onButtonClicked = (_event: any) => {
    this.userLogin = true;
    this.router.navigate(['/home']);
  }

  ngAfterViewChecked() {
    if (!this._navbarInitialized && this.navbarComponent) {
      this._navbarInitialized = true;
      this.navbarComponent.toggleSidenav();
      this.cdr.detectChanges();
    }
  }
  toggleMenu() {
    if (this.navbarComponent) {
      this.navbarComponent.toggleSidenav(); // Access child method
    }
  }

  async refreshToken() {
    if (sessionStorage.getItem('Refresh_token') !== 'undefined' && sessionStorage.getItem('Refresh_token') !== '' && sessionStorage.getItem('token') !== 'undefined' && sessionStorage.getItem('token') !== '' && sessionStorage.getItem('id_token') !== 'undefined' && sessionStorage.getItem('id_token') !== '') {
const data: any = {
        'grant_type': "refresh_token",
        'client_id':  globalThis.environment.clientId,
        'refresh_token': sessionStorage.getItem('Refresh_token')
      };
      const refreshBody = [];
      for (const property in data) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(data[property]);
        refreshBody.push(`${encodedKey}=${encodedValue}`);
      }
      const body = refreshBody.join("&");
      const tokenapi: ApiPayload = {
        'url':  globalThis.environment.tokenURL,
        'method': FETCH_METHODS['Post'],
        'headers': {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
        },
        'body': body,
        'type': 'token'
      }
      await this.globalApi.getDataFromDataSource(tokenapi).then((res: any) => {
        if (res !== null && res !== undefined && res !== '' && !res.hasOwnProperty('error')) {
          this.idToken = res.id_token
          this.accessToken = res.access_token
          this.refresToken = res.refresh_token
          sessionStorage.setItem('token', this.accessToken)
          sessionStorage.setItem('Refresh_token', this.refresToken)
          sessionStorage.setItem('id_token', this.idToken);
          const currentTime = Date.now();
          sessionStorage.setItem('lastModifiedOn', currentTime.toString());
        }
        if (res === null || res === undefined) {
          this.clearData();
        }
      }).catch(err => {
        console.info(err)
        this.clearData();
      })
    } else {
      this.clearData();
    }
  }
  clearData() {
    const confirmed = globalThis.confirm(ERROR_RESPONSE['tokenExpired']);
    if (confirmed) {
      sessionStorage.clear();
      globalThis.location.reload();
    }
  }

  assignMenuGroupAndRender() {
    this.commonUtils.spinner('show');
    const userInfo: any = JSON.parse(sessionStorage.getItem('UserInfo') ?? '');
    if (userInfo) {
      const workDayId = userInfo['workdayId'];
      this.fetchAndUpdateMenuGroups(workDayId).then(res => {
        if (Array.isArray(res) && res.length > 0) {
          userInfo[FieldNames['UserAccessRoles']] = res[0][FieldNames['UserAccessRoles']];
          userInfo[FieldNames['UserAccessScreens']] = res[0][FieldNames['UserAccessScreens']];
          this.commonUtils.userInfo = userInfo;
          this.isActive = true;
          this.applicationStatus = 'Render';
          this.router.navigateByUrl('/')
        } else {
          this.applicationStatus = 'Error'
        }
        this.commonUtils.spinner('hide');
      }).catch(err => {
        this.commonUtils.userInfo = {};
        console.info(err,'Error fetching user details')
        this.applicationStatus = 'Error'
        this.commonUtils.spinner('hide');
      })
    } else {
      this.commonUtils.userInfo = {};
      this.applicationStatus = 'Error'
    }

  }
  fetchAndUpdateMenuGroups(_workdayId: string) {
    const searchParam: SearchConfig = {
      path: 'getAccessControl',
      method: FETCH_METHODS['Post']
    };
    if (!searchParam['body']) {
      searchParam['body'] = {}
    }
    searchParam['body']['getLoggedUser'] = true;
   
    return this.commonService.getDataFromDataSource(searchParam, ApiEnvNames['UserAccess']).then(response => {
      if (response['status'] === API_STATUS['Success']) {
        if (Array.isArray(response.result)) {
          this.handleResult(response.result)
        }
      }
      return response.result
    }).catch(err => {
      console.info(ERROR_RESPONSE['layoutErrorPrefix'], err);
    })
  }
  handleResult(result: any[]) { 
    const data = result[0];
    if (data) {
     const userRole = data[FieldNames['UserAccessRoles']];
     data['userName'] = `${data['firstName']} ${data['lastName']}`
     this.commonService.loggedUserDetails = data;
      if(data[FieldNames['UserAccessScreens']].includes("tenureAdmin")){
        this.commonService.isTenureAdmin = true;
      }
      if ([User_Roles.Admin, User_Roles.Super_Admin].includes(userRole)) {
        this.commonService.isTenureAdmin = true;
        this.commonService.isAdmin = true;
        Object.values(menuItems).forEach(menu => {
          NavbarMenuItems.push(menu)
        })
        if (userRole === User_Roles.Super_Admin) {
          NavbarMenuItems.push(SuperAdminMenu)
        }
        if(data.workdayId==="628734" || data.workdayId==="561593" || data.workdayId==="450367" || data.workdayId==="579207"){
          NavbarMenuItems.push(EventAdminMenu)
        }
      } else {
        const availableScreens = data?.[FieldNames['UserAccessScreens']];
        if (availableScreens && availableScreens.length > 0) {
          availableScreens.forEach((screenName: any) => {
            if(menuItems[screenName]){
            NavbarMenuItems.push(menuItems[screenName]);
            }
          })
        }
      }
      NavbarMenuItems.sort((a, b) => a.menuId - b.menuId);
    }

  }
  openHelp(){
    const dialogRef = this.dialog.open(ChatBotComponent, {
      disableClose: true,
      panelClass: 'chat-bot'
    });
    dialogRef.afterClosed().subscribe(_result => {
    }); 
  }

}


